export default [
    {
        name: 'site_api',
        path: '/api/sites',
        redirect: '',
        meta: { requiresAuth: true }
    }
];
